import type { SingleFlagProps } from "./SingleFlag.d";

const SingleFlag = ({ flag: Flag }: SingleFlagProps) => <Flag w={{ base: 6, md: 8 }} h={{ base: 4, md: 6 }} mr={3} />;

export default SingleFlag;
